/**
 * File heading-banner.js.
 *
 * Handles heading hero text blocks.
 */
(function ($) {
    'use strict';
})(jQuery);